import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    getRankLName(data) {
        return axios.request({
            url: "arrange/grouplist",
            method: "get",
            params: data,
        });
    },
    getRankList(data) {
        return axios.request({
            url: "arrange/groupdetail",
            method: "get",
            params: data,
        });
    },
    compareGroupRank(params) {
        return axios.request({
            url: 'mwap/while-group-rank',
            method: 'get',
            params,
        });
    },
		getRankList2(data) {
		    return axios.request({
		        url: "arrange/scoredetail",
		        method: "get",
		        params: data,
		    });
		},
		editScore(data) {
		    return axios.request({
		        url: "arrange/editscore",
		        method: "get",
		        params: data,
		    });
		}
}